<template>
	<div>
		<div class="danger_container">
				<p style="margin: 4rem 0;" class="sub_menu_title">系统架构</p>
				<div class="danger_box_t">
					<div class="danger_box_t_list">
						<div class="sys_box">
							<div>
								<p class="danger_box_t_title">危化品库管理员</p>
								<p class="danger_box_t_msg">项目中的危化品申购审核、出入库管理由专业人士严控</p>
							</div>
							<img class="danger_box_t_img" src="../../../assets/static/images/guanli.png">
						</div>
					</div>
					<div class="danger_box_t_list">
						<div class="sys_box">
							<div>
								<p class="danger_box_t_title">实验室管理员</p>
								<p class="danger_box_t_msg">课题组相关申请，使用授权部分功能帮助管理</p>
							</div>
							<img class="danger_box_t_img" src="../../../assets/static/images/guanli.png">
						</div>
					</div>
					<div class="danger_box_t_list">
						<div class="sys_box">
							<div>
								<p class="danger_box_t_title">科研人员</p>
								<p class="danger_box_t_msg">科研人员使用时用量异常提醒、未归还提醒降低实验风险</p>
							</div>
							<img class="danger_box_t_img" src="../../../assets/static/images/keyan.png">
						</div>
					</div>
				</div>
				<div class="danger_box_b">
					<div class="danger_box_b_list">
						<div class="sys_box_list">
							<p class="danger_box_b_title">后台管理</p>
							<p class="danger_box_b_msg">后台危化品申请购，数据管理，查询实验室库存，使用授权功能给人员</p>
						</div>
						<img class="danger_box_b_img" src="../../../assets/static/images/houtai.png" />
					</div>
					<div class="danger_box_b_list">
						<div class="sys_box_list">
							<p class="danger_box_b_title">数据资源</p>
							<p class="danger_box_b_msg">后台对相关数据进行记录与统计，例如对人员流动和环境监测进行统计。</p>
						</div>
						<img class="danger_box_b_img" src="../../../assets/static/images/ziyuan.png" />
					</div>
					<div class="danger_box_b_list">
						<div class="sys_box_list">
							<p class="danger_box_b_title">物联网智能硬件</p>
							<p class="danger_box_b_msg">关联相关硬件：超高频RFID手持设备、危化品管控柜、智能中控台</p>
						</div>
						<img class="danger_box_b_img" src="../../../assets/static/images/wulian.png" />
					</div>
				</div>
			</div>
			<div class="danger_service_container_t">
				<p style="padding: 5rem 0 3.5rem 0;" class="sub_menu_title">业务模块功能</p>
				<div class="danger_service_list" >
					<div class="danger_service_box">
						<img class="danger_service_box_img"  src="../../../assets/static/images/money.png">
						<p class="danger_service_title">申购采购计划</p>
						<div class="danger_service_msg">
							<span >管理实验室采购计划</span>
							<br>
							<span>录入试剂信息与标签信息</span>
						</div>
						<img style="right: -5rem;" class="danger_service_img" src="../../../assets/static/images/right.png">
					</div>
					<div class="danger_service_box">
						<img  class="danger_service_box_img"  src="../../../assets/static/images/ruku.png">
						<p class="danger_service_title">赋码入库</p>
						<div class="danger_service_msg">
							<span >黏贴标签，智能称重</span>
							<br>
							<span>录入试剂信息与标签信息</span>
						</div>
						<img style="right: -5rem;" class="danger_service_img" src="../../../assets/static/images/right.png">
					</div>
					<div class="danger_service_box">
						<img class="danger_service_box_img"  src="../../../assets/static/images/chucun.png">
						<p class="danger_service_title">实验室储存</p>
						<div class="danger_service_msg">
							<span >智能称重，自动读取标签信息</span>
							<br>
							<span>危化品智能管控柜识别</span>
						</div>
						<img style="bottom: -5rem; transform:rotate(90deg) scale(0.7);" class="danger_service_img" src="../../../assets/static/images/right.png">
					</div>
					<div class="danger_service_box" style="visibility: hidden;">
						
					</div>
					<div class="danger_service_box">
						<img  class="danger_service_box_img"   src="../../../assets/static/images/wplingqu.png">
						<p class="danger_service_title" style="padding-top: 3rem;">物品领取</p>
						<div class="danger_service_msg">
							<span >远程授权、刷卡鉴权</span>
							<br>
							<span>开启柜门领取</span>
							<br>
							<span>关闭柜门后自动盘点</span>
							<br>
							<span>
								记录领取试剂信息
							</span>
						</div>
						<img style="top: -5rem;transform:rotate(270deg) scale(0.7);" class="danger_service_img" src="../../../assets/static/images/right.png">
					</div>
					<div class="danger_service_box" style="padding-top: 7rem;">
						<img   class="danger_service_box_img"  src="../../../assets/static/images/guihuan.png">
						<p class="danger_service_title"  style="">物品归还</p>
						<div class="danger_service_msg">
							
							<span >刷卡鉴权、智能称重，自动读取标签信息</span>
							<br>
							<span>开启柜门归还试剂，关闭柜门自动盘，</span>
							<br>
							<span>核对试剂信息，记录试剂用量</span>
						</div>
						<img style="left: -5rem; transform:rotate(180deg) scale(0.7);" class="danger_service_img" src="../../../assets/static/images/right.png">
					</div>
				</div>
				</div>
				<div class="danger_service_container_b">
					<p style="padding: 0rem 0 3.5rem 0;" class="sub_menu_title">业务模块功能</p>
					<div class="danger_service_list_b">
						<div class="danger_service_box_b">
							<img src="../../../assets/static/images/lingyong.png">
							<p class="danger_service_box_b_title">危化品仓库管理</p>
							<p class="danger_service_box_b_msg">危化品仓库管理包含危化品申购、入库申购，赋码入库、申领审核，危化品发
							放、危化品归还，危化品盘点、危化品处置等功能</p>
						</div>
						<div class="danger_service_box_b">
							<img src="../../../assets/static/images/lingyong.png">
							<p class="danger_service_box_b_title">实验室领用管理</p>
							<p class="danger_service_box_b_msg">管理课题组申购数量和价格管控，危化品申领，危化品出入库等，统计相关信息降低实验室风险。</p>
						</div>
						<div class="danger_service_box_b">
							<img src="../../../assets/static/images/shiyonggl.png">
							<p class="danger_service_box_b_title">危化品使用管理</p>
							<p class="danger_service_box_b_msg">基于危化品管控柜，管理取用授权，自动记录取用品类和用量，危化品用量异常提醒、试剂未归还提醒、使用统计等。</p>
						</div>
					</div>
					
				</div>
	</div>
	
</template>

<script>
	import { scrollAnimation } from '../../../utils/js/scrollAnimation.js';
	export default {
		created(){
			const currentY = document.documentElement.scrollTop || document.body.scrollTop
			scrollAnimation(currentY, 800)
		},
	}
</script>

<style lang="less" scoped>
	.danger_container {
		.danger_box_t {
			display: flex;
			width: 75rem;
			margin: 0 auto;
		}
	
		.danger_box_t_list {
			width: 24rem;
			height: 13.625rem;
			background: #FFFFFF;
			box-shadow: 0px 3px 8px 0px rgba(175, 175, 175, 0.5);
			margin: 0 1rem;
			padding: 2rem 0;
			padding-left: 1.5rem;
			padding-right: 1.5rem;
			border-radius: 8px;
		}
	
		.danger_box_t_title {
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
		}
	
		.danger_box_t_msg {
			font-size: 0.875rem;
			width: 13.75rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
		}
	
		.sys_box {
			display: flex;
			// justify-content: center;
			// align-items: center;
			flex-direction: column;
		}
	
		.danger_box_t_img {
			align-self: flex-end;
			margin-top: -6rem;
		}
	
		.danger_box_b {
			display: flex;
			width: 75rem;
			margin: 0 auto;
			margin-top: 1rem;
			justify-content: space-between;
		}
	
		.danger_box_b_list {
			position: relative;
			margin: 0 1rem;
			text-align: center;
		}
	
		.sys_box_list {
			position: absolute;
			top: 3rem;
			z-index: 50;
			padding: 0 1.5rem;
		}
	
		.danger_box_b_msg {
			text-align: left;
			font-size: 0.9375rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
			line-height: 1.3125rem;
		}
	
		.danger_box_b_title {
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
			margin-top: -1rem;
			padding-bottom: 0.5rem;
		}
	
		.danger_box_b_img {
			transform: scale(1);
			height: 26.5rem;
			width: 24rem;
			margin-left: -0.7rem;
	
		}
	}
	.danger_service_container_t{
		background: #F9FAFC;
		margin: 5rem 0;
	}
	.danger_service_list{
		display: flex;
		flex-wrap: wrap;
		width: 75rem;
		margin: 0 auto;
		align-items: flex-end;
		margin-top: -2rem;
		.danger_service_box{
			width: 20.375rem;
			height: 26.625rem;
			background: #FFFFFF;
			box-shadow: 0px 2px 11px 5px rgba(235,235,235,1);
			position: relative;
			margin: 3rem auto;
			background-image: url(../../../assets/static/images/tuoyuand.png) ;
			background-size: 100%;
			background-repeat: no-repeat;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			padding-top: 6rem;
		}
		.danger_service_box_img{
			// width: 7.25rem;
			height: 7.25rem;
			// margin-top: -5rem;
			// transform: scale(0.9);
			position: absolute;
			top: 2rem;
		}
		.danger_service_title{
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
			margin-top: 3rem;
		}
		.danger_service_msg_t{
			
		}
		.danger_service_msg_b{
			
		}
		.danger_service_img{
			position: absolute;
			transform: scale(0.7);
		}
		.danger_service_msg{
			text-align: center;
			
		}
		.danger_service_msg span{
			font-size: 0.9375rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
			
			padding: 0.25rem 1rem;
			display: inline-block;
			
		}
	}
	.danger_service_container_b{
		margin: 5rem 0;
		.danger_service_list_b{
			width: 75rem;
			margin: 0 auto;
			display: flex;
			justify-content: space-between;
		}
		.danger_service_box_b{
			width: 23.9375rem;
			height: 26.5rem;
			background: linear-gradient(130deg, #F1F6FF 0%, #C6D8FF 100%);
			border: 0.4375rem solid  rgba(149, 193, 255, 1);
			border-radius: 0.4375rem;
			display: flex;
			justify-content: center;
			flex-direction: column;
			align-items: center;
			justify-content: start;
			padding-top: 3rem;
		}
		.danger_service_box_b_title{
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #3A3A3A;
			padding-top: 3rem;
		}
		.danger_service_box_b_msg{
			font-size: 0.9375rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
			padding: 0 4.5rem;
			line-height: 1.5625rem;
		}
	}
</style>
